import React, { useRef } from 'react';

// Libs
import { CSSTransition } from 'react-transition-group';

type Props = {
  children?: React.ReactNode;
  onClick?: () => void;
  isShow: boolean;
  classes?: string;
  color?: 'white' | 'black';
};

const Mask = ({
  children,
  onClick,
  isShow,
  classes,
  color = 'black'
}: Props) => {
  // Refs
  const containerRef = useRef(null);
  const innerRef = useRef(null);

  return (
    <CSSTransition
      in={isShow}
      classNames={`mask-${color}`}
      timeout={300}
      nodeRef={containerRef}
      appear={true}
      mountOnEnter
      unmountOnExit
    >
      <div
        ref={containerRef}
        className={`fixed top-0 left-0 w-full h-screen ${classes}`}
        onClick={onClick}
      >
        <CSSTransition
          in={isShow}
          classNames='fade'
          timeout={300}
          nodeRef={innerRef}
          appear={true}
        >
          <div ref={innerRef}>{children}</div>
        </CSSTransition>
      </div>
    </CSSTransition>
  );
};

export default Mask;
